module.exports = __webpack_public_path__ + "static/media/GelBoxFullBuffer.f158becb.svg";